(function () {
  function formatCounterNumber(value) {
    return Math.round(value).toLocaleString('en-US');
  }

  function animateCounter(counter) {
    if (!counter || counter.dataset.counterAnimated === 'true') {
      return;
    }

    var target = parseInt(counter.getAttribute('data-counter-value'), 10);
    var prefix = counter.getAttribute('data-counter-prefix') || '';
    var suffix = counter.getAttribute('data-counter-suffix') || '';

    if (Number.isNaN(target)) {
      return;
    }

    counter.dataset.counterAnimated = 'true';

    var duration = 1400;
    var startTime = null;

    function updateCounter(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }

      var progress = Math.min((timestamp - startTime) / duration, 1);
      var easedProgress = 1 - Math.pow(1 - progress, 3);
      var currentValue = target * easedProgress;

      counter.textContent = prefix + formatCounterNumber(currentValue) + suffix;

      if (progress < 1) {
        window.requestAnimationFrame(updateCounter);
      } else {
        counter.textContent = prefix + formatCounterNumber(target) + suffix;
      }
    }

    window.requestAnimationFrame(updateCounter);
  }

  function animateSectionCounters(container) {
    if (!container) {
      return;
    }

    container.querySelectorAll('[data-landing-counter]').forEach(function (counter) {
      animateCounter(counter);
    });
  }

  function initLandingAboutUs(container) {
    if (!container || container.dataset.landingAboutUsInitialized === 'true') {
      return;
    }

    container.dataset.landingAboutUsInitialized = 'true';

    var stats = container.querySelector('[data-landing-about-us-stats]');

    if (!stats) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      animateSectionCounters(container);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateSectionCounters(container);
            observer.disconnect();
          }
        });
      },
      {
        threshold: 0.25,
      },
    );

    observer.observe(stats);
  }

  function initAllLandingAboutUs() {
    document.querySelectorAll('[data-landing-about-us]').forEach(function (container) {
      initLandingAboutUs(container);
    });
  }

  document.addEventListener('DOMContentLoaded', initAllLandingAboutUs);

  document.addEventListener('shopify:section:load', function (event) {
    initLandingAboutUs(event.target.querySelector('[data-landing-about-us]'));
  });
})();
